module.exports = __webpack_public_path__ + "media/components/assets/images/tamgeulAllkill/image3-a9e1c09f7c016c009811387c49448e4e.png";